'use strict';

const jQuery = require('jquery');

const Container = require('./../../../core/container');

const Rte = require('./../../../services/rte');
const TextPlaceholder = require('./../service/textPlaceholder');

const ContentManager = require('./../component/ContentManager');
const UserPreferenceRepository = require('./../repository/UserPreferenceRepository');
const SaveManager = require('./../component/SaveManager');
const Plugin = require('./index');

let publishState = false;

module.exports.initParameterRte = function() {
  jQuery('body').on('mousedown', '[data-parameter-rte]', function(event) {
    let $currentTarget = jQuery(event.currentTarget);
    let content = ContentManager.getContentByNode($currentTarget.parents('.bb-content:first'));

    if (Container.get('isAllowedTo')('EDIT_CONTENT')) {
      Rte.create({
        '$element': $currentTarget,
        'content': content,
        'parameter': true,
      });
    }

    event.stopPropagation();
  });
};

module.exports.onMousedown = function(content) {
  if (content.isRteEditable()) {
    let isGlobalContent = content.$.parents('footer').length || content.$.parents('nav').length;

    if (isGlobalContent) {
      if (!Container.get('isAllowedTo')('GLOBAL_CONTENT_FEATURE')) {
        return true;
      }
    } else {
      if (!(Container.get('isAllowedTo')('EDIT_CONTENT') || Container.get('isAllowedTo')('CREATE_CONTENT'))) {
        return true;
      }
    }

    let $content = content.$.find('[data-cloud-rte]');

    if (!$content.length) {
      $content = content.$;
    }

    if ($content.attr('data-cloud-rte')) {
      Rte.create({'$element': $content, 'content': content});
    }
  }
};

module.exports.beforeRteCreate = function(config) {
  let $publish = Container.get('$toolbar').find('.btn.btn-publish:first');

  publishState = $publish.hasClass('is-drafted');

  config.$element.find('.cloud-edit-content, .cloud-dnd-content').remove();

  // Prevent the timeout session
  UserPreferenceRepository.find('rte');

  if (config.content) {
    config.content.currentRteValue = config.$element.html();
  }

  Container.get('$siteWrapper').addClass('rte');
};

module.exports.afterRteCreate = function(config) {
  TextPlaceholder.unApplyToElement(config.$element);
};

module.exports.afterRteDestroy = function(config) {
  let content = config.content;
  let parameterName;

  config.$element.find('.cloud-edit-content').remove();

  if (content && jQuery.trim(content.currentRteValue) !== jQuery.trim(config.$element.html())) {
    if (config.parameter) {
      parameterName = config.$element.data('parameter-name');
      if (parameterName) {
        content.addParameter(parameterName, config.$element.html());
      }
    } else {
      content.addElement('value', config.$element.html());
    }

    if (config.save !== false) {
      SaveManager.save();
    }
  }

  TextPlaceholder.globalApply();

  Container.get('$siteWrapper').removeClass('rte');

  Plugin.onClick(content, true);
};

module.exports.onRteChange = function(config) {
  let content = config.content;
  let $btnPublish = Container.get('$toolbar').find('.btn.btn-publish:first');

  if (content) {
    if (jQuery.trim(content.currentRteValue) !== jQuery.trim(config.instance.getData())) {
      $btnPublish.addClass('is-drafted');
    } else if (!publishState) {
      $btnPublish.removeClass('is-drafted');
    }
  }
};
